import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useQuery, useMutation } from '@apollo/client';
import { GET_WHERE_TO_GO_ITEM, UPDATE_WHERE_TO_GO_ITEM } from '../graphql/whereToGo';
import WhereToGoForm from '../components/WhereToGoForm';
import { toast } from 'react-hot-toast';

export default function EditWhereToGo() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  
  const { loading: loadingItem, data, error: queryError } = useQuery(GET_WHERE_TO_GO_ITEM, {
    variables: { id },
    skip: !id
  });

  const [updateWhereToGo, { loading: updating }] = useMutation(UPDATE_WHERE_TO_GO_ITEM, {
    onCompleted: () => {
      toast.success('Location updated successfully!');
      navigate('/dashboard/where-to-go');
    },
    onError: (error) => {
      setError(error.message);
      toast.error(`Error updating location: ${error.message}`);
    }
  });

  const handleSubmit = async (formData) => {
    if (!id) return;

    try {
      setError(null);
      await updateWhereToGo({
        variables: {
          input: {
            id,
            ...formData
          }
        }
      });
    } catch (err) {
      console.error('Update error:', err);
    }
  };

  if (loadingItem) {
    return (
      <div className="p-6">
        <div className="animate-pulse space-y-4">
          <div className="h-8 bg-gray-200 rounded w-1/4"></div>
          <div className="space-y-2">
            <div className="h-4 bg-gray-200 rounded"></div>
            <div className="h-4 bg-gray-200 rounded w-5/6"></div>
          </div>
        </div>
      </div>
    );
  }

  if (queryError) {
    return (
      <div className="p-6">
        <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg">
          Error loading location: {queryError.message}
        </div>
      </div>
    );
  }

  if (!data?.whereToGoItem) {
    return (
      <div className="p-6">
        <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg">
          Location not found.
        </div>
      </div>
    );
  }

  return (
    <>
      {error && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 text-red-600 rounded-lg">
          {error}
        </div>
      )}
      <WhereToGoForm
        initialData={data.whereToGoItem}
        onSubmit={handleSubmit}
        isLoading={updating}
      />
    </>
  );
} 